import { type } from "../../types/types";

export default function reducer(state = { categories: [] }, action) {
  switch (action.type) {
    case type.SET_CATEGORIES:
      return { ...state, ...action.categories };
    default:
      return state;
  }
}
